import api from '../api'
import { ERROR, LOADING } from '../constants/globalConstants'
import {
  ADD_SONG,
  EDIT_SONG,
  GET_SONG,
  GET_SONGS,
  SEARCH_SONGS,
  DELETE_SONG
} from '../constants/songConstants'

export const addSong = (title, body, link, navigate) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await api.post('/songs/new', { title, body, link }, config)
    dispatch({
      type: ADD_SONG
    })

    navigate(`/song/${data._id}`)
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getSongs = () => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.get('/songs')
    dispatch({
      type: GET_SONGS,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    alert('Something went wrong')
  }
}

export const searchSongs = (search) => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.get(`/songs?search=${search ? search : ''}`)
    dispatch({
      type: SEARCH_SONGS,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    alert('Something went wrong')
  }
}

export const getSong = (id) => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.get(`/songs/song/${id}`)
    dispatch({
      type: GET_SONG,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    alert('Something went wrong')
  }
}

export const editSong = (id, title, link, body, navigate) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await api.put(`/songs/song/${id}`, { title, link, body }, config)
    dispatch({
      type: EDIT_SONG
    })

    navigate(`/song/${data._id}`)
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deleteSong = (id, navigate) => async (dispatch, getState) => {
  try {
    if (window.confirm('Are you sure? This CANNOT be undone!')) {
      const { userState: { userInfo: { token } } } = getState()
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }

      await api.delete(`/songs/song/${id}`, config)
      dispatch({
        type: DELETE_SONG,
        payload: id
      })

      navigate('/')
    }
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    alert('Something went wrong')
  }
}